export function isAuthenticated(harenaLocalStorage: string): boolean {
  const userObject = JSON.parse(harenaLocalStorage);
  return Boolean(
    userObject?.auth || userObject?.token || userObject?.accessToken,
  );
}
